import { render, staticRenderFns } from "./DealTermsAndFeatures.vue?vue&type=template&id=cbdd24a2&scoped=true&"
import script from "./DealTermsAndFeatures.vue?vue&type=script&lang=js&"
export * from "./DealTermsAndFeatures.vue?vue&type=script&lang=js&"
import style0 from "./DealTermsAndFeatures.vue?vue&type=style&index=0&id=cbdd24a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbdd24a2",
  null
  
)

export default component.exports